import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim"
import {
    appPayMethod, i18n, loading, outputDiv, reCAPTCHAv3
} from "commonAssets/js/constants";
import { createElement } from "commonAssets/lib/createElement";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { DigitalDisbursements } from "commonAssets/components/FormBase/DigitalDisbursements";
import { FormFields, FormFieldsLabel } from "commonAssets/components/FormBase/FormFields";
import { modal } from 'commonAssets/lib/modal';
import { validateField } from 'commonAssets/lib/validateField';
import { clearMessage } from 'commonAssets/lib/clearMessage';
import { toggleFieldError } from 'commonAssets/lib/toggleFieldError';
import { loadMember } from 'commonAssets/lib/loadMember';
import { ConfirmEmailAddress } from 'commonAssets/lib/ConfirmEmailAddress';
import { localDatetime } from 'commonAssets/lib/localDatetime';
import { uniformClaimDeadline } from 'commonAssets/lib/uniformClaimDeadline';
import { dstMember } from 'commonAssets/components/FormBase/DigitalDisbursements';
import { ErrorHandler } from 'commonAssets/utils/ErrorHandler';
import { validRequire } from "commonAssets/lib/validRequire";
import { validDate } from "commonAssets/lib/validDate";
import { validMinDate } from "commonAssets/lib/validMinDate";
import { validMaxDate } from "commonAssets/lib/validMaxDate";
import { formatDate } from "commonAssets/lib/formatDate";
import formDefault from "../../docs/formDefault.json";

const toBool = (value) => {
    if (value === true || value === 1 || value === "1") {
        return true;
    }

    if (value === false || value === 0 || value === "0") {
        return false;
    }

    return undefined;
};

const getClaimAccess = (resultData) => {
    const envelope = resultData?.class_member ?? resultData;

    return {
        isClaimDeficient: toBool(
            envelope?.is_claim_deficient ??
                resultData?.is_claim_deficient ??
                envelope?.is_deficient ??
                resultData?.is_deficient
        ) === true,
        isClaimEditable: toBool(
            envelope?.is_claim_editable ??
                resultData?.is_claim_editable ??
                envelope?.can_edit ??
                resultData?.can_edit
        ) === true,
        deficiencyReason:
            envelope?.deficiency_reason ??
            envelope?.deficiency_reasons ??
            resultData?.deficiency_reason ??
            resultData?.deficiency_reasons ??
            "",
    };
};

const shorted_names = {
    'Number of Doses': 'Doses',
    'Program Participant': 'Participant'
}

const custom_validation = [
    'Start Date',
    'End Date'
]

export const customFormFieldsLabel = (field, fieldID, div) => {
    let fieldLabel = i18n.getField(field.label);
    const star = (field.required) ? "*" : "";
    if (
        field.type === "text" ||
        field.type === 'autocomplete' ||
        field.type === "number" ||
        field.type === "date" ||
        field.type === "textarea" ||
        field.type === "select"
    ) {
        const label = createElement("label", { for: field.name }, [], `${shorted_names[fieldLabel] || fieldLabel}${star} <span class="error"></span>`);
        div.appendChild(label);
    }
}

export class customSubmitClaim extends SubmitClaim {

    async form() {
        const form = formDefault.claim_form[this.lang]
        this.init_claim(form)
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                if (form.form_options.notice_confirmation.display === true) {
                    container.appendChild(this.guard(form, datetime));
                    outputDiv.appendChild(container);

                    const zero_zero_id = document.getElementById("zero_zero_id");
                    const confirmation_code = document.getElementById("confirmation_code");

                    [zero_zero_id, confirmation_code].forEach((input) => {
                        input.addEventListener("change", validateField);
                    });

                    document.getElementById("submit-guard").addEventListener("click", () => {
                        document.getElementById("guard").classList.add("was-validated");
                    });

                    document.getElementById("guard").addEventListener("submit", (e) => {
                        e.preventDefault();

                        let valid = true;
                        const member = {
                            domain: this.claim.data.domain,
                            zero_zero_id: zero_zero_id.value.toUpperCase(),
                            confirmation_code: confirmation_code.value,
                        };

                        clearMessage();

                        [zero_zero_id, confirmation_code].forEach((input) => {
                            valid = validateField(input) && valid;
                        });
                        if (!valid) return;

                        loadingGif(loading, "show");

                        this.claim.api
                            .classMemberPost({}, member)
                            .then((memberResult) => {
                                if (memberResult.data.error) {
                                    toggleFieldError(zero_zero_id, true, "");
                                    toggleFieldError(confirmation_code, true, "");
                                    this.errorHandler.log_exception(
                                        new Error("Error loading class member", {
                                            cause: memberResult,
                                        })
                                    );
                                    this.errorHandler.display_modal(memberResult);
                                    return;
                                }

                                const access = getClaimAccess(memberResult.data);

                                if (!access.isClaimDeficient || !access.isClaimEditable) {
                                    loadingGif(loading, "hide", 250);
                                    modal(
                                        i18n.getTranslation("error"),
                                        "<p class='mb-0 text-center'>This portal is not open to new claims. If you received a deficiency notice, please contact the settlement administrator for assistance.</p>"
                                    );
                                    return;
                                }

                                this.claim.deficiency_reason = access.deficiencyReason;
                                this.claim.data.zero_zero_id = member.zero_zero_id;
                                this.claim.data.confirmation_code = member.confirmation_code;

                                const environment = this.claim.data.domain.split(".")[0];

                                if (memberResult.data.claim_id) {
                                    this.claim.data.claim_id = memberResult.data.claim_id;
                                    this.claim.class_member = memberResult.data;
                                    if (environment !== "local") {
                                        this.send_otp(
                                            form,
                                            container,
                                            memberResult.data,
                                            claim_deadline
                                        );
                                        return;
                                    }
                                }

                                this.populate_claim_form(
                                    form,
                                    container,
                                    memberResult.data,
                                    claim_deadline
                                );
                            })
                            .catch((error) => {
                                this.errorHandler.log_exception(
                                    new Error("Error loading class member", {
                                        cause: error,
                                    })
                                );
                                this.errorHandler.display_modal(error);
                            });
                    });
                } else {
                    this.edit_claim(form);

                    const deadlineSpan = uniformClaimDeadline(claim_deadline);
                    container.appendChild(this.claim_form(form, deadlineSpan));
                    outputDiv.appendChild(container);

                    this.init_claim_fields(this.claim, form, claim_deadline);
                }

                loadingGif(loading, "hide", 250);
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error fetching claim deadline", { cause: error })
                );
                this.errorHandler.display(error);
            });
    }

    static createInstance({ appClaimForm, userLanguage, customInitClaim = null, customProcessClaim = null, customLoadMember = null, customDstProcess = null, errorHandler = new ErrorHandler() }) {
        return new customSubmitClaim(appClaimForm, userLanguage, customInitClaim, customProcessClaim, customLoadMember, customDstProcess, errorHandler)
    }

    claim_form(params, additionalParams) {
        console.log("[claim_form]")
        // update the claim form deadline
        const deadline_heading = params.form_options.claim_deadline_alert.claim_form;
        const deadline_parser = new DOMParser();
        const deadline_string = deadline_parser.parseFromString(deadline_heading, "text/html");
        const deadline_date_string = deadline_string.querySelector("span");
        // if deadline_date_string is null, then the deadline is not set
        // the if condition was added due to error in i18n translation
        // TODO: remove this if condition after fixing the i18n translation
        if (deadline_date_string !== null) {
            deadline_date_string.textContent = additionalParams;
        }

        // const the form
        const form = createElement("form", {
            class: "needs-validation",
            id: "form",
            method: "post"
        }, [
            createElement("h3", {
                class: "text-center mb-3",
                id: "claimFormDeadline"
            }, [], deadline_string.body.innerHTML),
            createElement("div", {
                class: "alert alert-info text-center fw-bold text-dark",
                id: "confirmation-email-alert",
                role: "alert"
            }, [], params.form_options.claim_form.confirmation_email_notice),
            this.claim_instructions(params),
            this.claim_contact_information(params),
            params.claim_transactions ? this.claim_transactions(params) : ``,
            this.claim_fieldset(params),
            params.claim_upload.documentation.required ? this.claim_documentation(params) : ``,
            appPayMethod ? DigitalDisbursements(params) : ``,
            this.claim_certification(params),
        ]);
        return form;
    }

    claim_transactions(params) {
        if (params.claim_transactions === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_transactions.length === 0) {
            return createElement("div", { class: "d-none" });
        }

        const fieldset = createElement("div", {
            class: "bg-light text-dark border rounded p-3 mb-5",
            id: "transactions"
        }, [
            createElement("div", {
                class: "h3 mb-3 formTitle",
            }, [], params.form_options.transactions.title),
            createElement("div", {
                class: "mb-3 formBody"
            }, [], params.form_options.transactions.body),
        ]);

        // For Each Transaction Table
        const claim_transactions = params.claim_transactions;
        let tableID = 0;
        claim_transactions.forEach(table => {
            tableID++; // Begin count at 1.

            // <div class="table-responsive"></div>
            const divResponsiveTable = createElement("div", { class: "table-responsive mb-3", id: "table_responsive_" + tableID });

            // <table class="table transactions"></table>
            const tableTransaction = createElement("table", {
                class: "table table-hover transactions caption-top",
                id: "transactions_" + tableID,
                "data-table-name": table.name,
                "data-table-id": tableID,
            }, [
                //createElement("caption", { class: "text-dark bg-transparent" }, [], "<strong>" + table.name + "</strong> &mdash; " + table.description),
            ]);
            divResponsiveTable.appendChild(tableTransaction);

            // <thead class="bg-dark text-light"></thead>
            const tableTHEAD = createElement("thead", { class: "table-dark text-light" });
            tableTransaction.appendChild(tableTHEAD);

            // <tr> ...Table Data Cells... </tr>
            const theadTR = createElement("tr");
            tableTHEAD.appendChild(theadTR);

            // <th scope="col"></th>
            table.columns.forEach(col => {
                const column = createElement("th", { scope: "col" }, [], col.title);
                theadTR.appendChild(column);

                if (Boolean(col.body)) {
                    const helper = createElement("span", { class: "d-block fw-normal", style: "font-size:16px;" }, [], col.body);
                    column.appendChild(helper);
                }
            });

            // <tbody></tbody>
            const tableTBODY = createElement("tbody");
            tableTransaction.appendChild(tableTBODY);

            // Add rows through a function, so we can attach a button.
            let countRow = 1;
            this.claim_transaction_row(table, tableTBODY, tableID, countRow);

            const add_row = createElement("div", {
                class: "text-center",
            }, [
                createElement("a", {
                    class: "btn btn-primary m-1",
                    id: "add_transactions_" + tableID,
                    role: "button",
                    tabindex: "0",
                    "aria-label": i18n.getTranslation('transaction_add_row') + table.name,
                    "tableID": tableID,
                }, [], `<i class="bi bi-plus-circle" tableID="${tableID}"></i> ${table.name}`),
                createElement("a", { // ada compliance updates - added
                    class: "btn btn-danger m-1 disabled", // default to disabled
                    id: "remove_transactions_" + tableID,
                    role: "button",
                    tabindex: "0",
                    "aria-label": i18n.getTranslation('transaction_delete_row'),
                    "tableID": tableID,
                }, [], `<i class="bi bi-dash-circle" tableID="${tableID}"></i> ${i18n.getTranslation('transaction_delete_row')}`),
            ])

            // ada compliance updates - added
            this.claim_transaction_row_buttons_events(add_row, table, tableTBODY, tableID, countRow);

            // Append the table to the fieldset
            fieldset.appendChild(divResponsiveTable);
            fieldset.appendChild(add_row);
        });

        return fieldset;
    }

    claim_transaction_row(table, tableTBODY, tableID, countRow) {
        const fieldsRow = createElement("tr", {
            class: "transaction-row", // ada compliance updates - added
            id: "transaction_row_" + tableID + "_" + countRow, // ada compliance updates - added
        });
        tableTBODY.appendChild(fieldsRow);

        let fieldID = 0;
        table.fields.forEach(field => {
            fieldID++;
            let td = createElement("td", { class: "transaction " + field.name, });
            let element = createElement("div");
            let validation = field.validation;

            let formInput = FormFields(field, "", fieldID, element, validation, fieldsRow);

            // set unique name for each field
            field.name = field.name + "__" + countRow;
            customFormFieldsLabel(field, fieldID, element);

            // set unique id for each field
            formInput.id = formInput.id + "__" + countRow;
            // set item-id attribute
            formInput.setAttribute("item-id", countRow);

            if (formInput.type == 'date') {
                const today = new Date().toISOString().split('T')[0];
                formInput.setAttribute("max", today);
                formInput.setAttribute("data-date-max", today);

                formInput.addEventListener('change', () => {
                    customValidateField(formInput);
                });
            }

            element.appendChild(formInput);
            td.appendChild(element);
            fieldsRow.appendChild(td);
        });
        return { tableTBODY, fieldsRow };
    }

    claim_fieldset(params) {
        if (params.claim_fields_sectioned === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_fields_sectioned.length === 0) {
            return createElement("div", { class: "d-none" });
        }
        const claimFields = createElement("div", {
            id: "claim-fields"
        }, [
            this.claim_field_sections(params)
        ])
        return claimFields;
    }

    claim_field_sections(params) {
        const claimFieldSections = createElement("div", {});

        params.claim_fields_sectioned.forEach((section) => {
            claimFieldSections.append(createElement("fieldset", { class: "bg-light text-dark border rounded p-3 mb-5" }, [
                createElement("div", { class: "h3 mb-3 formTitle" }, [], section.title),
                createElement("div", { class: "mb-3 formBody" }, [], section.body),
                this.claim_fields(section.fields),
            ]))
        })

        return claimFieldSections;
    }

    claim_fields(fields) {
        const container = createElement("div");

        let fieldID = 0;  //
        fields.forEach(field => {
            if (field.type == 'table') {
                container.appendChild(this.claim_field_table(field));
                return;
            }
            let element;
            let validation;
            let className = field.className ? field.className : ``;

            const div = createElement("div", {
                class: (field.parentClass ? field.parentClass : "mb-3 _wrapper"),
                "data-field-id": "_" + (field.name ? field.name : "_wrapper_" + fieldID)
            });
            element = FormFields(field, className, fieldID, element, validation, container);
            FormFieldsLabel(field, fieldID, div);

            div.append(element);
            container.appendChild(div);
            fieldID++;
        });

        return container;
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[populate_claim_form]");
        const access = getClaimAccess(class_member);

        if (!access.isClaimDeficient || !access.isClaimEditable) {
            this.errorHandler.display({
                status: 403,
                error: "This claim is no longer editable. Please contact the settlement administrator for assistance.",
            });
            return;
        }

        this.claim.deficiency_reason = access.deficiencyReason;
        // set user for error tracking
        this.errorHandler.set_user({ id: class_member.zero_zero_id, email: class_member.email_address });
        // remove guard
        document.getElementById('guard').remove();
        // claim_deadline format December 31, 2024 at 04:00:00 P.M. 
        let deadlineSpan = uniformClaimDeadline(claim_deadline);
        // New Claim Form
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        // output
        outputDiv.appendChild(container);
        // hide loading gif
        loadingGif(loading, "hide", 250);
        // Load member data into form
        loadMember(class_member);
        // custom login member code
        document.getElementById('first_name').disabled = document.getElementById('first_name').value;
        document.getElementById('last_name').disabled = document.getElementById('last_name').value;
        if (class_member.claim_id) {
            if (class_member?.claim_files?.length > 0) this.claim.prev_docs = true;
        }
        // Payment widget 
        if (appPayMethod && appPayMethod !== "") {
            dstMember();
        }
        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
    }

    init_claim_inputs_loop() {
        for (var type in this.claim.inputs) {
            if (this.claim.inputs[type] && this.claim.inputs[type].length > 0) {
                this.claim.inputs[type].forEach(function (field) {
                    // Check for validation attribute
                    if (field.hasAttribute('data-validate')) {
                        // Attach change event handler for validation
                        if (custom_validation.includes(field.getAttribute('data-label'))) {
                            field.addEventListener('change', function (e) {
                                customValidateField(field);
                            });
                        } else {
                            field.addEventListener('change', function (e) {
                                validateField(field);
                            });
                        }
                    }
                });
            }
        }
    }

    process_claim(e, claim, deadline) {
        console.log("[process_claim]")

        /**
         * Prevent the default form submission.
         * 
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         * 
         * Since: 2023.09.25
         * 
         * @returns {void}
         */
        document.getElementById('submit-claim').disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById('documentation')) {
            this.process_claim_files(this.claim);
        }

        if (document.getElementById('email_address') && document.getElementById('confirm_email_address')) {
            ConfirmEmailAddress('process', this.claim);
        }

        // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        // if (appPayMethod && appPayMethod !== "" && this.customDstProcess === null) {
        //     claim = dstProcess(this.claim);
        // }
        // else if (appPayMethod && appPayMethod !== "" && this.customDstProcess !== null) {
        //     claim = this.customDstProcess(this.claim);
        // }

        /**
         * Define the environment for the s3 uploader.
         */
        let s3env = this.config.url;

        let custom_errors = '';

        let docs_uploaded = this.claim.prev_docs || claim.uploads.length > 0;
        if (((document.getElementById('number_of_treatments_proof_of_treatment').value && document.getElementById('number_of_treatments_proof_of_treatment').value > 0) || document.getElementById('number_of_treatments_proof_of_out_of_pocket_costs').value && document.getElementById('number_of_treatments_proof_of_out_of_pocket_costs').value > 0) && !docs_uploaded) {
            custom_errors += `<br>Please upload supporting documentation.`
            claim.flags.valid = false;
        }

        if (!document.getElementById('payment_method') || !document.getElementById('payment_token') || !document.getElementById('payment_method').value || !document.getElementById('payment_token').value) {
            custom_errors += `<br>${i18n.getTranslation('payment_select_error')}`;
            claim.flags.valid = false;
        }

        if (document.getElementById('email_address').value && document.getElementById('payment_email').value && document.getElementById('email_address').value.toLowerCase() != document.getElementById('payment_email').value.toLowerCase()) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_email_error')}`;
            claim.flags.valid = false;
        }

        if (document.getElementById('phone_number_1').value && document.getElementById('payment_phone').value && document.getElementById('phone_number_1').value.replace(/\D/g, '') != document.getElementById('payment_phone').value.replace(/\D/g, '')) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_phone_error')}`;
            claim.flags.valid = false;
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            var error = document.querySelector('label.error, #file-notice.error, #no-files.error');
            let timeout = 0;
            if (error && typeof error.scrollIntoView == 'function') {
                error.scrollIntoView({ behavior: "smooth" });
                timeout = 500;
            }
            setTimeout(() => {
                modal(i18n.getTranslation('error'), i18n.getTranslation('claim_form_errors') + custom_errors);
            }, timeout);
        }
    }

    format_claim_data(claim) {
        for (var type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    var label = field.getAttribute('data-label') || field.name;
                    var item_id = field.getAttribute('item-id') || null;
                    var data_field;

                    if (field.hasAttribute('data-validate')) {
                        if (custom_validation.includes(field.getAttribute('data-label')) && !customValidateField(field)) {
                            claim.flags.valid = false;
                        } else if (!validateField(field)) {
                            claim.flags.valid = false;
                        }
                    }
                    if (claim.flags.valid) {
                        if (item_id) {
                            if (!claim.data[type][item_id]) claim.data[type][item_id] = {};
                            data_field = claim.data[type][item_id];
                        } else {
                            data_field = claim.data[type];
                        }
                        switch (field.type) {
                            case 'radio':
                                if (field.checked) data_field[label] = field.value;
                                break;
                            case 'checkbox':
                                field.checked ? data_field[label] = field.value : data_field = 'No';
                                break;
                            default:
                                data_field[label] = field.value;
                        }
                    }
                });
            }
        }
    }

    destroy_claim(claim) {
        loadingGif(loading, "hide", 500); // left here

        if (claim.flags.success) {

            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector('div.display-form').classList.add('d-none');

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            outputDiv.scrollIntoView({ behavior: "smooth" });

            setTimeout(() => {
                modal(i18n.getTranslation('confirmation_screen_additional')['title'], i18n.getTranslation('confirmation_screen_additional')['body']);
            }, 250);

            fbq('track', 'Lead');

            gtag("event", "generate_lead", {
                currency: "USD",
                value: 1
            });

            rdt('track', '{{Conversion event}}', {
                conversion_id: '{{Conversion ID}}'
            });
            
        } else {
            modal(i18n.getTranslation('error'), i18n.getTranslation('claim_submit_error'));
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (var type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(document.querySelectorAll('input[type="radio"]'), function (radio) {
            radio.setAttribute('disabled', 'disabled');
        });

        document.getElementById('submit-claim').setAttribute('disabled', 'disabled');
    }
}

export function customValidateField(e) {
    var field = (e instanceof Event) ? e.target : e;
    var validation = field.getAttribute('data-validate').split(' ');

    toggleFieldError(field, false);

    if (validation.includes('required') && !validRequire(field)) {
        toggleFieldError(field, true, i18n.getTranslation('required'));
        return false;
    }

    if (field.value) {
        if (validation.includes('date') && !validDate(field)) {
            toggleFieldError(field, true, 'Invalid');
            return false;
        }

        if (field.min && !validMinDate(field)) {
            toggleFieldError(field, true, `Minimum date is ${formatDate(field.getAttribute('data-date-min'))}`);
            return false;
        }

        if (field.max && !validMaxDate(field)) {
            toggleFieldError(field, true, `Maximum date is ${formatDate(field.getAttribute('data-date-max'))}`);
            return false;
        }
    }

    return compareTxDates(field.getAttribute('item-id'));
}

export function compareTxDates(itemId) {
    const startDateInput = document.querySelector(`[data-label="Start Date"][item-id="${itemId}"]`);
    const endDateInput = document.querySelector(`[data-label="End Date"][item-id="${itemId}"]`);

    toggleFieldError(endDateInput, false);

    if (startDateInput.value && endDateInput.value) {
        const startDate = new Date(startDateInput.value);
        const endDate = new Date(endDateInput.value);

        if (startDate > endDate) {
            toggleFieldError(endDateInput, true, "End date must be after start date.");
            return false;
        }

    }

    return true;
}
